import { useMemo } from 'react';

import { useResponsive } from '@sg/garnish';

import { useFeatureFlag } from '@order/LaunchDarkly';

import { Navbar } from '../../../../../components/Navbar';
import { NavbarV2 } from '../../../../../components/NavbarV2';
import {
  CONTENT_WITH_BG_COLOR_STYLES,
  SCREEN_HEADER_OPTIONS,
  STATIC_WITH_BORDER_NAVBAR_SCREEN_OPTIONS,
  type ScreenOptions,
  type ScreenOptionsMap,
} from '../../../../constants';
import { useRouteTitles } from '../../../messages';

// ─────────────────────────────────────────────────────────────────────────────

export const useAuthStackOptions = () => {
  const { match } = useResponsive();

  const titles = useRouteTitles();
  const isNavbarV2Enabled = useFeatureFlag('CELS-5440-order-navbar-v2-enabled');

  // ─────────────────────────────────────────────────────────────────────

  const stackOptions = useMemo(() => {
    return {
      ...SCREEN_HEADER_OPTIONS,
      headerShown: true,
      header: match([undefined, isNavbarV2Enabled ? renderNavbarV2 : renderLegacyNavbar]),
      presentation: match(['modal', 'transparentModal']),
      contentStyle: CONTENT_WITH_BG_COLOR_STYLES,
    } satisfies ScreenOptions;
  }, [isNavbarV2Enabled, match]);

  // ─────────────────────────────────────────────────────────────────────

  return useMemo(() => {
    return {
      //
      // ─── Main Stack Options (applied to all screens) ─────────────────────

      Stack: stackOptions,

      // ─── Individual Screen Options ───────────────────────────────────────

      JoinOrSignIn: {
        ...STATIC_WITH_BORDER_NAVBAR_SCREEN_OPTIONS,
        customDocumentTitle: titles.joinOrSignInCustomDocumentTitle,
      },
    } satisfies ScreenOptionsMap;
  }, [stackOptions, titles]);
};

// ─── Helpers ─────────────────────────────────────────────────────────────────

function renderLegacyNavbar() {
  return <Navbar />;
}

function renderNavbarV2() {
  return <NavbarV2 />;
}
